import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Text extends Component {
  static propTypes = {
    id: PropTypes.string,
    item: PropTypes.node,
    classNames: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    classNames: '',
  };

  render() {
    const { classNames, item, children, id } = this.props;

    if (children || React.isValidElement(item)) {
      const component = children || item;

      return (
        <span id={id} className={classNames}>
          {component}
        </span>
      );
    }

    // eslint-disable-next-line react/no-danger
    return <span id={id} className={classNames} dangerouslySetInnerHTML={{ __html: item }} />;
  }
}
